const Charging_Icon = ({ className = "" }) => {
  return (
    <svg
      width="16"
      height="16"
      className={className}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="8.00008" cy="7.99984" r="7.33333" fill="#6CCCDF" />
      <circle
        cx="8.00008"
        cy="7.99984"
        r="7.33333"
        fill="url(#paint0_linear_462_8809)"
        fill-opacity="0.7"
      />
      <path
        d="M11.325 6.175L9.93002 7.57C9.77002 7.73 9.88001 8 10.105 8H11C11 9.655 9.65501 11 8.00002 11C7.60502 11 7.22002 10.925 6.87502 10.78C6.69502 10.705 6.49002 10.76 6.35502 10.895C6.10002 11.15 6.19002 11.58 6.52502 11.715C6.98002 11.9 7.48002 12 8.00002 12C10.21 12 12 10.21 12 8H12.895C13.12 8 13.23 7.73 13.07 7.575L11.675 6.18C11.58 6.08 11.42 6.08 11.325 6.175ZM5.00002 8C5.00002 6.345 6.34502 5 8.00002 5C8.39502 5 8.78002 5.075 9.12502 5.22C9.30502 5.295 9.51002 5.24 9.64502 5.105C9.90002 4.85 9.81002 4.42 9.47502 4.285C9.02002 4.1 8.52002 4 8.00002 4C5.79002 4 4.00002 5.79 4.00002 8H3.10502C2.88002 8 2.77002 8.27 2.93002 8.425L4.32502 9.82C4.42502 9.92 4.58002 9.92 4.68002 9.82L6.07502 8.425C6.23002 8.27 6.12002 8 5.89502 8H5.00002Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_462_8809"
          x1="1.71437"
          y1="-0.555703"
          x2="15.3929"
          y2="-0.138834"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#0085FF" stop-opacity="0" />
          <stop offset="0.932292" stop-color="#0085FF" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default Charging_Icon;
